import { inject, Injectable } from "@angular/core";
import { ApiResponse, StatusFlags } from "./data.model";
import { DataService } from "./data.service";
import { Nav } from "./nav.model";
import { Modules } from "@urls";

@Injectable({ providedIn: 'root' })
export class NavService {
  public preparedNavigations: Nav[] = [];
  public dataService = inject(DataService);

  public async getNavigations() {
    if (localStorage.ProNavigation) {
      this.preparedNavigations = JSON.parse(localStorage.ProNavigation);
      return true;
    }

    return await this.dataService.get<Nav[]>(`${Modules.MyNavigation}`).then((response: ApiResponse<Nav[]>) => {
      if (response.status === StatusFlags.Success && response.data && response.data.length) {
        localStorage.ProNavigation = JSON.stringify(response.data);
        this.preparedNavigations = JSON.parse(localStorage.ProNavigation);
        return true;
      } else { return false; }
    })
  }
}